export default "__VITE_ASSET__CgO$0RJy__"